import type { QueryClient } from '@tanstack/react-query';
import { createContext } from 'react-router';

// The one QueryClient reaches route loaders through router context, never a
// module-level import (ADR 0016 § 1).
export const queryClientContext = createContext<QueryClient>();
